<template>
    <span>
        <v-card class="rounded_card quaroshadow" id="line_chart_card" style="height: 100% !important">
            <div class="backsheet" aria-hidden="true"></div>

            <v-menu offset-y rounded="lg" color="primary" transition="slide-y-transition" bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" fab color="primary" top small right absolute id="chart_menu" aria-haspopup="dialog" aria-controls="line-chart-actions" aria-label="Open chart menu">
                        <v-icon aria-hidden="true">mdi-dots-vertical</v-icon>
                    </v-btn>
                </template>
                <v-list id="line-chart-actions" rounded dense role="menu" aria-label="Chart actions">
                    <v-list-item class="pl-2" role="menuitem" @click="openDownloadDialog('chartmenu')">
                        <v-icon class="mr-2" aria-hidden="true">mdi-cloud-download</v-icon>
                        <v-list-item-title>Download Chart</v-list-item-title>
                    </v-list-item>

                    <v-list-item class="pl-2" role="menuitem" @click="clearChart">
                        <v-icon class="mr-2" aria-hidden="true">mdi-refresh</v-icon>
                        <v-list-item-title>Reset Chart</v-list-item-title>
                    </v-list-item>

                    <v-list-item class="pl-2" role="menuitem" @click="openSettingsDialog('chartmenu')">
                        <v-icon class="mr-2" aria-hidden="true">mdi-cog</v-icon>
                        <v-list-item-title>Settings</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-card-title class="sheet-card-title">
                <h2 style="align-items: center; display: flex; flex-wrap: wrap; font-size: 1.25rem; font-weight: 500; letter-spacing: 0.0125em; line-height: 2rem; word-break: break-all">
                    {{ graphCardData.title }}
                </h2>
            </v-card-title>
            <v-card-subtitle>
                {{ graphCardData.subTitle }}
            </v-card-subtitle>
            <v-slide-y-transition>
                <v-card-text v-if="!hidden" role="region" aria-label="Line chart of search volumes">
                    <line-chart :dataChart="dataChart" :countGraph="countGraph" :countGraph2="countGraph2" :options="graphOptions"></line-chart>
                </v-card-text>
            </v-slide-y-transition>
        </v-card>

        <!-- SETTINGS -->
        <v-dialog v-model="chartSettingsDialog.display" eager scrollable max-width="350px" id="chart-settings-dialog" @keydown.esc.stop="closeSettingsDialog">
            <v-card ref="settingsCard" role="dialog" aria-modal="true" aria-labelledby="settings-title" aria-describedby="settings-desc" tabindex="-1">
                <h2 id="settings-title" class="sr-only">{{ chartSettingsDialog.title }}</h2>
                <p id="settings-desc" class="sr-only">Use arrow keys to adjust the sliders. Press Enter/Space to toggle switches. Press Escape to close.</p>
                <strong id="settings-title" class="d-inline-block">{{ chartSettingsDialog.title }}</strong>
                <v-card-text class="pt-5">
                    <!-- erster sinnvoller Fokuspunkt: der Switch -->
                    <span class="ma-5" v-for="(slider, i) in settingsSlider" :key="i">
                        <v-slider
                            ref="settingSliders"
                            v-model="slider.value"
                            class="align-center"
                            :max="slider.max"
                            :min="slider.min"
                            thumb-label
                            hide-details
                            :aria-label="slider.label"
                            @change="changeSettings()">
                            <template v-slot:append>
                                <div aria-hidden="true">{{ slider.value }}</div>
                            </template>
                            <template v-slot:prepend>
                                <div class="labeldiv">{{ slider.label }}</div>
                            </template>
                        </v-slider>
                    </span>

                    <v-divider></v-divider>

                    <v-switch ref="settingsFirstFocus" v-model="beginAtZero" label="Always start at zero" aria-label="Toggle y-axis start at zero" @change="changeSettings()"></v-switch>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="closeSettingsDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- DOWNLOAD -->
        <v-dialog v-model="chartDownloadDialog.display" eager scrollable max-width="350px" id="chart-download-dialog" @keydown.esc.stop="closeDownloadDialog">
            <v-card ref="downloadCard" role="dialog" aria-modal="true" aria-labelledby="download-title" aria-describedby="download-desc" tabindex="-1">
                <h2 id="download-title" class="sr-only">{{ chartDownloadDialog.title }}</h2>
                <p id="download-desc" class="sr-only">Choose a format. Press Escape to close; focus will return to the Download button.</p>
                <strong id="download-title" class="d-inline-block">{{ chartDownloadDialog.title }}</strong>

                <v-card-text class="pt-5">
                    <center>
                        <v-btn ref="downloadFirstFocus" color="primary" large rounded @click="downloadChart(0)" aria-label="Download chart as PDF"> Download as PDF </v-btn>
                    </center>
                    <br />
                    <center>
                        <v-btn color="primary" large rounded @click="downloadChart(1)" aria-label="Download chart as PNG"> Download as PNG </v-btn>
                    </center>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="closeDownloadDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
    import LineChart from "./LineChart"
    import canvasToImage from "canvas-to-image"
    import { jsPDF } from "jspdf"

    export default {
        components: {
            LineChart
        },
        name: "KeywordLineChart",
        props: {
            headers: Object,
            keywords: Array,
            graphloaded: Boolean,
            loading: Boolean,
            dataChart: Object,
            countGraph: Number,
            countGraph2: Number,
            render: Number,
            showAfterFirstHalf: Boolean,
            settingsLineChart: Number,
            downloadLineChart: Number,
            resetLineChart: Number,
            hidden: Boolean
        },
        data: () => ({
            beginAtZero: false,
            focusOrigin: null,
            settingsSlider: [
                {
                    value: 14,
                    min: 10,
                    max: 20,
                    label: "Label Size"
                },
                {
                    value: 14,
                    min: 10,
                    max: 20,
                    label: "Axis Label Size"
                },
                {
                    value: 12,
                    min: 10,
                    max: 20,
                    label: "Legend Label Size"
                }
            ],
            chartSettingsDialog: {
                display: false,
                title: "Chart Settings"
            },
            chartDownloadDialog: {
                display: false,
                title: "Chart Download"
            },
            graphCardData: {
                title: "Google Search Volume",
                subTitle: "Analyze Google Search Volume of past months"
            },
            graphOptions: {
                responsive: true,
                maintainAspectRatio: false,

                // v2: "animation" (nicht "animations")
                animation: { duration: 300 },

                // Hover/Tooltip-Zielgenauigkeit
                hover: { mode: "nearest", intersect: false },

                legend: {
                    display: true,
                    labels: {
                        fontSize: 13,
                        boxWidth: 12,
                        padding: 14
                    }
                },

                tooltips: {
                    mode: "index",
                    intersect: false,
                    backgroundColor: "rgba(0,0,0,0.85)",
                    titleFontSize: 13,
                    bodyFontSize: 13,
                    xPadding: 12,
                    yPadding: 10,
                    displayColors: true,
                    callbacks: {
                        // Sicher: gibt leeren String zurück, wenn kein Label vorhanden
                        title: function (items) {
                            return items && items[0] && items[0].label ? items[0].label : ""
                        },
                        // Zahlformat ohne Intl/navigator (rein regexbasiert)
                        label: function (tooltipItem, data) {
                            var ds = data && data.datasets ? data.datasets[tooltipItem.datasetIndex] : null
                            var label = ds && ds.label ? ds.label : "Value"
                            // Rohwert robust ermitteln (Dataset oder yLabel)
                            var raw = ds && ds.data && ds.data[tooltipItem.index] != null ? ds.data[tooltipItem.index] : tooltipItem.yLabel
                            var n = Number(raw) || 0
                            var formatted = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            return label + ": " + formatted
                        }
                    }
                },

                // v2-Achsen-Syntax
                scales: {
                    xAxes: [
                        {
                            gridLines: { color: "#e6e6e6" },
                            ticks: {
                                maxRotation: 0,
                                autoSkip: true,
                                fontSize: 12,
                                padding: 6
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: { color: "#e6e6e6" },
                            ticks: {
                                // Setze hier hart "true" (sicher). Wenn du toggeln willst, siehe Hinweis unten.
                                beginAtZero: true,
                                fontSize: 12,
                                padding: 6,
                                callback: function (value) {
                                    var n = Number(value) || 0
                                    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                }
                            }
                        }
                    ]
                },

                layout: {
                    padding: { left: 0, right: 12, top: 0, bottom: 0 }
                }
            },
            datasetBtns: []
        }),
        computed: {
            user_settings() {
                return this.$store.state.user_settings
            }
        },
        watch: {
            render() {
                this.initPieChart(this.keywords, this.headers)
            },
            settingsLineChart() {
                this.openSettingsDialog("chartsettings")
            },
            downloadLineChart() {
                // eigener Origin für den Download aus ChartSettings
                this.openDownloadDialog("chartsettings-download")
            },
            resetLineChart() {
                this.clearChart()
            },
            // ⬇️ NEU: Sobald der Settings-Dialog wirklich offen ist, Fokus setzen
            "chartSettingsDialog.display"(val) {
                if (val) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            // 1) Versuch: ersten Slider fokussieren (Vuetify: Fokus liegt auf dem Element mit role="slider")
                            const refs = this.$refs.settingSliders
                            const firstSliderCmp = Array.isArray(refs) ? refs[0] : refs
                            const firstSliderEl = firstSliderCmp && (firstSliderCmp.$el || firstSliderCmp)
                            const sliderFocusTarget = firstSliderEl && (firstSliderEl.querySelector('[role="slider"]') || firstSliderEl.querySelector("input"))

                            if (sliderFocusTarget && typeof sliderFocusTarget.focus === "function") {
                                sliderFocusTarget.focus()
                                return
                            }

                            // 2) Fallback: der Switch, sonst die Card
                            const el = (this.$refs.settingsFirstFocus && this.$refs.settingsFirstFocus.$el) || (this.$refs.settingsCard && (this.$refs.settingsCard.$el || this.$refs.settingsCard))
                            this.focusFirstIn(el)
                        }, 0)
                    })
                }
            },

            // ⬇️ NEU: Gleiches fürs Download-Dialog
            "chartDownloadDialog.display"(val) {
                if (val) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            const el = (this.$refs.downloadFirstFocus && this.$refs.downloadFirstFocus.$el) || (this.$refs.downloadCard && (this.$refs.downloadCard.$el || this.$refs.downloadCard))
                            this.focusFirstIn(el)
                        }, 0)
                    })
                }
            }
        },
        methods: {
            // ---------- Fokus-Helfer ----------
            focusFirstIn(el) {
                if (!el) return
                const first = el.querySelector('input, button, [href], select, textarea, [role="switch"], .v-input__slot [tabindex="0"], [tabindex]:not([tabindex="-1"])') || el
                if (typeof first.focus === "function") first.focus()
            },
            returnFocus() {
                if (this.focusOrigin === "chartsettings-download") {
                    // zurück zum Download-Button im ChartSettings-Panel
                    this.$parent?.$refs?.chartSettings?.restoreFocus?.("btnLineDownload")
                } else if (this.focusOrigin === "chartsettings") {
                    // zurück zum Zahnrad-Button im ChartSettings-Panel
                    this.$parent?.$refs?.chartSettings?.restoreFocus?.("btnLineSettings")
                } else {
                    // zurück zum Kebab-Button im Chart (Menü rechts oben)
                    const btn = document.getElementById("chart_menu")
                    if (btn && typeof btn.focus === "function") btn.focus()
                }
                this.focusOrigin = null
            },
            // ---------- Settings ----------
            openSettingsDialog(origin) {
                this.focusOrigin = origin
                this.chartSettingsDialog.display = true
                this.$nextTick(() => {
                    setTimeout(() => {
                        // 1) Versuch: erstes Slider-Input fokussieren
                        const refs = this.$refs.settingSliders
                        const firstSliderEl = (Array.isArray(refs) ? refs[0] : refs) && (Array.isArray(refs) ? refs[0] : refs).$el
                        const sliderInput = firstSliderEl && firstSliderEl.querySelector("input")
                        if (sliderInput && typeof sliderInput.focus === "function") {
                            sliderInput.focus()
                            return
                        }
                        // 2) Fallback: vorhandener Switch oder Card-Inhalt
                        const el = (this.$refs.settingsFirstFocus && this.$refs.settingsFirstFocus.$el) || (this.$refs.settingsCard && (this.$refs.settingsCard.$el || this.$refs.settingsCard))
                        this.focusFirstIn(el)
                    }, 50)
                })
            },

            closeSettingsDialog() {
                this.chartSettingsDialog.display = false
                this.$nextTick(() => this.returnFocus())
            },

            // ---------- Download ----------
            openDownloadDialog(origin) {
                this.focusOrigin = origin
                this.chartDownloadDialog.display = true
                this.$nextTick(() => {
                    setTimeout(() => {
                        const el = (this.$refs.downloadFirstFocus && this.$refs.downloadFirstFocus.$el) || (this.$refs.downloadCard && (this.$refs.downloadCard.$el || this.$refs.downloadCard))
                        this.focusFirstIn(el)
                    }, 50)
                })
            },
            closeDownloadDialog() {
                this.chartDownloadDialog.display = false
                this.$nextTick(() => {
                    setTimeout(() => this.returnFocus(), 80)
                })
            },

            /**
             * calculates datasets for selected columns
             * @param {*} headers
             * @param {*} keywords
             */
            initLineChart(headers, keywords) {
                // ---------------- filters all possible pie columns //TODO needed ???
                let lineHeaders = headers.modifiedHeaders.filter((header) => (header.custom && header.customOptions.type == "Dropdown") || header.value == "cats")
                // ---------------- filters columns which are set to active
                lineHeaders = lineHeaders.filter((header) => {
                    if (header.chart_options && header.chart_options.line_chart) {
                        return header.chart_options.pie_chart.status.active === true
                    }
                    return false
                })
                // ---------------- return if no colums for pie Charts
                if (lineHeaders.length === 0) return

                this.datasetBtns = lineHeaders.map((header, index) => {
                    let datasetBtn = {}
                    datasetBtn.color = ""
                    datasetBtn.id = index
                    datasetBtn.text = header.modifiedText
                    datasetBtn.value = header.value
                    datasetBtn.isActive = index === 0 ? true : false
                    return datasetBtn
                })
                console.log("this.datasetBtns: ", this.datasetBtns)
                console.log("this.dataChart", this.dataChart)
                // per header build multiplse datsets per attribute
                this.createAllDatasets(keywords, lineHeaders)
                // backgroundColor: CanvasGradient
                // borderColor: "rgba(0, 159, 137, 0.8)"
                // borderWidth: 3.5
                // data: Array(14)
                // hidden: false
                // label: "Sum of all keywords"
                // pointBackgroundColor: "white"
                // pointBorderColor: "grey"
                // this.createAllDatasets(keywords, lineHeaders)
                // this.setActiveDataset(this.datasetBtns[0])
            },
            /** creates and sets all datasets
             * @param {Array} keywords  all keywords rows
             * @param {Array} lineHeaders custom headers with type dropdown
             */
            createAllDatasets(keywords, lineHeaders) {
                console.log(keywords)
                let datasets = lineHeaders.map((header, index) => {
                    let dataset = {}
                    if (header.value == "cats") {
                        // dataset = this.getCategoryDataSet(keywords, header, index)
                    } else {
                        let data = header.customOptions.entries.map((optionEntry) => {
                            let keywordsWithOption = keywords.filter((keyword) => keyword.customs[header.value].text == optionEntry.text)
                            keywordsWithOption = keywordsWithOption.filter((keyword) => keyword)
                            console.log(keywordsWithOption)
                            let graphObjects = this.$helpers.buildGraphObjects([], keywordsWithOption, this.dataChart.datasets, this.dataChart.labels)
                            console.log(graphObjects)
                        })
                        dataset = {
                            id: index,
                            borderWidth: 3,
                            // borderColor: this.borderColors(header),
                            // backgroundColor: this.getBackgroundColors(header),
                            data: this.getDataByOptionEntries(keywords, header),
                            hidden: true

                            // labels: this.getDatasetLabels(header)
                        }
                    }
                    return dataset
                })

                console.log(datasets)
                let sortedDatasets = this.sortDatasets(datasets)
                this.chartData.datasets = datasets
            },
            /**
             * helper for creating Datasets | sums up searchvolume for Entries
             * @param {Array}   keywords
             * @param {Array}   header
             * @returns {Array} data
             */
            getDataByOptionEntries(keywords, header) {
                let data = header.customOptions.entries.map((optionEntry) => {
                    let keywordsWithOption = keywords.filter((keyword) => keyword.customs[header.value].text == optionEntry.text)
                    let sum = this.$helpers.sumUpByAttribute(keywordsWithOption, "annualsv")
                    return sum
                })
                return data
            },
            changeSettings() {
                this.setChartOptions()
                // console.log(JSON.stringify(this.user_settings))
                if (JSON.stringify(this.user_settings) !== "{}") {
                    this.user_settings.line_chart_labelsize = this.settingsSlider[0].value
                    this.user_settings.line_chart_axislabelsize = this.settingsSlider[1].value
                    this.user_settings.line_chart_legendlabelsize = this.settingsSlider[2].value
                    this.user_settings.line_chart_alwaysstartatzero = this.beginAtZero
                    this.$store.dispatch("CHANGE_USER_SETTINGS", this.user_settings)
                }
            },
            setChartOptions() {
                console.log("setChartOptions")

                this.graphOptions.scales = {
                    xAxes: [
                        {
                            ticks: {
                                fontSize: this.settingsSlider[0].value
                            },
                            display: true,
                            scaleLabel: {
                                fontSize: this.settingsSlider[1].value,
                                display: true,
                                labelString: "Months"
                            }
                        }
                    ],
                    yAxes: [
                        {
                            ticks: {
                                fontSize: this.settingsSlider[0].value,
                                beginAtZero: this.beginAtZero,
                                callback: function (value, index, values) {
                                    return value.toLocaleString()
                                }
                            },
                            display: true,
                            scaleLabel: {
                                fontSize: this.settingsSlider[1].value,
                                display: true,
                                labelString: "Google Search Volume"
                            }
                        }
                    ]
                }
                this.graphOptions.legend = {
                    display: true,
                    labels: {
                        fontSize: this.settingsSlider[2].value
                    }
                }
                this.$emit("rerender")
            },
            clearChart() {
                this.$emit("clearChart")
            },
            downloadChart(format) {
                /***********
                 * 0 -> PDF
                 * 1 -> PNG
                 **********/
                const canvasEl = document.getElementById("line-chart")
                if (format === 0) {
                    const doc = new jsPDF("landscape")
                    const ratio = canvasEl.width / canvasEl.height
                    const width = doc.internal.pageSize.getWidth()
                    const height = width / ratio
                    doc.addImage(canvasEl, "PNG", 0, height / 2, width, height)
                    doc.save("Google Search Volume.pdf")
                } else if (format === 1) {
                    canvasToImage(canvasEl, {
                        name: "Google Search Volume",
                        type: "png",
                        quality: 1
                    })
                }
            }
        },
        mounted() {
            this.settingsSlider[0].value = this.user_settings.line_chart_labelsize == undefined ? 14 : this.user_settings.line_chart_labelsize
            this.settingsSlider[1].value = this.user_settings.line_chart_axislabelsize == undefined ? 14 : this.user_settings.line_chart_axislabelsize
            this.settingsSlider[2].value = this.user_settings.line_chart_legendlabelsize == undefined ? 12 : this.user_settings.line_chart_legendlabelsize
            this.beginAtZero = this.user_settings.line_chart_alwaysstartatzero == undefined ? false : this.user_settings.line_chart_alwaysstartatzero

            this.setChartOptions()
            // if (this.keywords && this.keywords.length > 0 && this.headers.modifiedHeaders.length > 0) {
            //     this.initLineChart(this.headers, this.keywords)
            // }
        }
    }
</script>

<style scoped>
    #settings-title,
    #download-title {
        padding-top: 16px;
        line-height: 25px;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        text-align: center !important;
        color: #212529;
        font-size: 1em;
    }

    /* Screenreader-only Hilfsklasse */
    /* Screen-reader only helper (no visual size impact) */
    .sr-only {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 1px, 1px) !important;
        white-space: nowrap !important;
        border: 0 !important;
    }

    /* Fokus sichtbar machen für Buttons im Dialog */
    ::v-deep .v-btn:focus-visible,
    ::v-deep .v-slider .v-slider__thumb:focus-visible,
    ::v-deep .v-input--switch .v-input__slot:focus-within {
        outline: 3px solid #005fcc;
        outline-offset: 2px;
    }
    .rounded_card {
        border-radius: 10px !important;
    }
    .labeldiv {
        width: 110px;
    }
    .switchlabel {
        width: auto;
    }
</style>
<style lang="scss">
    #line_chart_card > div.v-card__text {
        flex-grow: 1;
        min-height: 0;
        height: 35vh;
        max-height: 400px;
        > div {
            position: relative;
            height: 100%;
        }
    }

    .rounded_card {
        border-radius: 10px !important;
    }

    // @media screen and (max-height: 1173px) {
    //     #linechart_col {
    //         max-height: 40vh;
    //     }
    // }
    // @media screen and (min-height: 1173px) {
    //     #linechart_col {
    //         height: 36vh;
    //     }
    //     #line_chart_card > div.v-card__text {
    //         flex-grow: 1;
    //         min-height: 0;
    //         // height: 85%;
    //         > div {
    //             position: relative;
    //             height: 95%;
    //         }
    //     }
    // }
</style>
